// packages/shared-hooks/src/users/useCreateUser.ts
// Spec §18. POST /users → created User; invalidate ['users', 'list'] so the
// UsersListPage refetches after creation.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserSchema, type CreateUserInput, type User } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useCreateUser() {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<User, unknown, CreateUserInput>({
    mutationFn: (input) => client.post<User>('/users', input, {}, UserSchema),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users', 'list'] }),
  });
}
